import React from "react";
import {
  FaExchangeAlt,
  FaFileContract,
  FaHeadset,
  FaShieldAlt,
  FaUsers,
  FaWater,
} from "react-icons/fa";

function WhyChoose() {
  const reasons = [
    {
      title: " Dedicated Support",
      desc: " Our team provides round-the-clock support, ensuring that any issues or questions are promptly addressed to keep your platform running smoothly.",
      icon: <FaHeadset size={35} />,
    },
    {
      title: "Experienced Team",
      desc: "With years of expertise in blockchain and exchange development, our skilled developers create reliable, high-performance margin trading platforms tailored to your needs.",
      icon: <FaUsers size={35} />,
    },
    {
      title: "Standard Development Practice",
      desc: "We follow industry-standard development practices, ensuring secure, compliant, and scalable platforms with robust functionality and future-ready infrastructure..",
      icon: <FaShieldAlt size={35} />,
    },
  ];
  return (
    <>
      <div
        className="services-area pt-120 pb-120"
        style={{ background: "#ffffff" }}
      >
        <div className="container text-center">
          <h2 className="title mb-4">Why Choose Xeer Technology</h2>

          <p
            className="mt-2 mb-5 mx-auto text-muted fs-5"
            style={{ maxWidth: "800px" }}
          >
            As decentralized development vanguards, our technically astute
            developers consistently synthesize complex enterprise requirements.
          </p>

          <div className="row g-4 justify-content-center">
            {reasons.map((reason, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="reason-card border-0 p-5 text-center h-100"
                  style={{
                    borderRadius: "32px",
                    background: "#f9faff",
                    border: "1px solid #f0f3ff",
                    transition: "all 0.4s ease",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.boxShadow =
                      "0 25px 50px rgba(0, 0, 0, 0.04)";
                    e.currentTarget.style.borderColor = "#3366ff20";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.background = "#f9faff";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#f0f3ff";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "70px",
                      height: "70px",
                      fontSize: "28px", // untouched
                      backgroundColor: "#ffffff",

                      borderRadius: "20px",
                      boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                    }}
                  >
                    {reason.icon}
                  </div>

                  <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                    {reason.title}
                  </h5>

                  <p
                    style={{
                      fontSize: "14px",
                      color: "#6c757d",
                      lineHeight: "1.7",
                      marginBottom: 0,
                    }}
                  >
                    {reason.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default WhyChoose;
